export const CONTENT_TYPE = "Content-Type";
export const ACCEPT = "Accept";
export const APPLICATION_JSON = "application/json";
export const APPLICATION_X_WWW_FORM_URLENCODED = "application/x-www-form-urlencoded";

export enum SOURCE_SYSTEM {
  SOL = "SOL",
  SIGII = "SIGII",
  GENESIS = "GENESIS",
  CORPOINT = "CORPOINT",
  PROFAT = "PROFAT",
}

export enum MODULE {
  DELIVERY = "delivery",
  DELIVERY_EXCHHANGE = "delivery-exchange",
  PICKUP = "pickup",
  ASSISTANCE_SERVICE = "assistance-service",
  SUPPLY_MATERIAL_SERVICE = "supply-material-service",
  SOL_CUSTOMER = "sol_customer",
  DEPOSIT = "deposit",
}

export enum SERVICEPOINT_TYPE {
  CASHTODAY = "CASHTODAY",
  SOL = "SOL",
}

export enum EXTRADATA_TYPE {
  BOOLEAN = "boolean",
  NUMBER = "number",
  TEXT = "text",
  SCANNABLE = "scannable",
}

export enum BARCODE {
  CODABAR = "CODABAR",
  CODE_128 = "CODE_128",
  CODE_39 = "CODE_39",
  CODE_93 = "CODE_93",
  EAN_13 = "EAN_13",
  EAN_8 = "EAN_8",
  ITF = "ITF",
  IMB = "IMB",
  MAXICODE = "MAXICODE",
  MSI = "MSI",
  PLESSEY = "PLESSEY",
  PDF_417 = "PDF_417",
  QR_CODE = "QR_CODE",
  RSS_14 = "RSS_14",
  RSS_EXPANDED = "RSS_EXPANDED",
  UPC_A = "UPC_A",
  UPC_E = "UPC_E",
  UPC_EAN_EXTENSION = "UPC_EAN_EXTENSION",
}
